// extracted by mini-css-extract-plugin
export default {"delete-equipment":"delete-equipment_bvkYSeF7"};